import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  BoardCommentsProcessingStateEnum,
  IBoardActivityFetchModel,
  IBoardActivityList,
  IBoardActivityUpdateModel,
} from '../../models/Comments'

const initialState = {
  data: null as IBoardActivityList | null,
  loading: false,
  error: null as string | null,
  processingState: null as BoardCommentsProcessingStateEnum | null,
}
const commentsSlice = createSlice({
  name: 'boardComments',
  initialState,
  reducers: {
    fetchCommentsRequest: (
      state,
      _: PayloadAction<IBoardActivityFetchModel>
    ) => {
      state.loading = true
      state.error = null
    },
    fetchCommentsSuccess: (
      state,
      action: PayloadAction<IBoardActivityList>
    ) => {
      state.loading = false
      state.data = action.payload
    },
    fetchCommentsError: (state, action) => {
      state.loading = false
      state.error = action.payload
    },

    fetchCommentsSilentRequest: (
      state,
      _: PayloadAction<IBoardActivityUpdateModel>
    ) => {
      state.error = null
    },
    fetchCommentsSilentSuccess: (
      state,
      action: PayloadAction<IBoardActivityList>
    ) => {
      state.data = action.payload
    },
    fetchCommentsSilentError: (state, action) => {
      state.error = action.payload
    },

    createCommentsRequest: (
      state,
      _: PayloadAction<IBoardActivityUpdateModel>
    ) => {
      state.error = null
      state.processingState = BoardCommentsProcessingStateEnum.Addcomment
    },
    createCommentsSuccess: (state) => {
      state.processingState = null
    },
    createCommentsError: (state, action) => {
      state.error = action.payload
      state.processingState = null
    },

    editCommentsRequest: (
      state,
      _: PayloadAction<IBoardActivityUpdateModel>
    ) => {
      state.error = null
      state.processingState = BoardCommentsProcessingStateEnum.Editcomment
    },
    editCommentsSuccess: (state) => {
      state.loading = false
      state.processingState = null
    },
    editCommentsError: (state, action) => {
      state.loading = false
      state.error = action.payload
      state.processingState = null
    },

    deleteCommentsRequest: (
      state,
      _: PayloadAction<IBoardActivityUpdateModel>
    ) => {
      state.loading = true
      state.processingState = BoardCommentsProcessingStateEnum.Deletecomment
    },
    deleteCommentsSuccess: (state) => {
      state.loading = false
      state.processingState = null
    },
    deleteCommentsError: (state, action) => {
      state.error = action.payload
      state.processingState = null
    },
  },
})

export default commentsSlice
